import { render, staticRenderFns } from "./ViButton.vue?vue&type=template&id=61dd733b&"
import script from "./ViButton.vue?vue&type=script&lang=js&"
export * from "./ViButton.vue?vue&type=script&lang=js&"
import style0 from "./ViButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports